import styled from 'styled-components';
import { FONTS, COLORS } from '@ertelecom/ui-react/assets/js/constants';
import DefaultPopup from '@ertelecom/ui-react/components/popups/defaultPopup';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton';
// @ts-ignore
import InputSimple, { phoneDecorator } from '@ertelecom/ui-react/components/inputSimple';
import styledButton from '@ertelecom/ui-react/components/buttons/styledButton';

const InputPhone = phoneDecorator(InputSimple);

export const Card = styled.div<{ oneRow: boolean, bgColor?: string, isCarousel: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  padding-top: 24px;
  border-radius: 8px;
  background: ${COLORS.white};
  transition: 0.3s;
  margin: ${({ isCarousel }) => isCarousel ? '0 16px' : '0'};
  min-height: ${props => props.oneRow ? '528px' : 'auto'};
  overflow: hidden;
  max-width: 316px;
  height: 100%;

  :before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 135%;
    height: 63%;
    background: ${({ bgColor }) => `radial-gradient(35.28% 33.14% at 82.28% 16.75%, ${bgColor} 0%, rgba(255, 0, 0, 0) 100%)`}, transparent;
    z-index: 0;
  }

  @media (max-width: 819px) {
    max-width: ${({ isCarousel }) => isCarousel ? '316px' : '100%'};
    margin: 0 auto ${props => props.oneRow ? '0' : '16px'};
  }

  ${({ isCarousel }) => {
      if (isCarousel) {
          return `@media (max-width: 1279px) {
                    max-width: 100%;
                  }
                  
                  @media (max-width: 911px) {
                    max-width: 350px;
                  }
                  
                  @media (max-width: 885px) {
                    max-width: 316px;
                  }
                  
                  @media (max-width: 776px) {
                    max-width: 283px;
                  }
                  
                  @media (max-width: 767px) {
                    max-width: 100%;
                    margin-left: 20px;
                    width: 100%;
                  }
                  `;
      }
  }}

  :hover {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.07);
  }
`;

export const HeaderBlock = styled.div`
  flex-direction: column;
  flex-wrap: nowrap;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  padding: 24px;
  height: 40px;
  width: 100%;
  gap: 4px;
`;

export const DescriptionBlock = styled.div`
  display: flex;
  flex-direction: row;
  font-family: ${FONTS.regular};
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: ${COLORS.darkGrey};
  margin-top: 0;
  margin-bottom: 3px;
  flex-grow: 4;
`;

export const PurchaseBlock = styled.div`
  display: block;
  margin-top: 24px;

  @media (max-width: 768px) {
    margin-top: -16px;
  }
`;

export const ContentBlock = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  padding: 0 24px 24px;
  width: 100%;
  flex-grow: 1;
`;

export const ImageBlock = styled.div<{ isCarousel: boolean }>`
  position: relative;
  z-index: 1;
  align-items: center;
  justify-content: center;
  height: 150px;
  width: 100%;
  margin-bottom: 16px;
  margin-top: 32px;

  a {
    display: inline-block;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
  }

  img {
    width: 100%;
  }

  @media (max-width: 645px) {
    margin-top: 0;
  }
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: flex-end;
    margin-top: 20px;
`;

export const Button = styled(styledButton)<{ isConnected?: boolean }>`
  max-width: ${({ isConnected }) => isConnected ? '117px' : 'fit-content'};
  min-width: ${({ isConnected }) => isConnected ? '117px' : '143px'};
  align-self: flex-end;
  max-height: 48px;
`;

export const OkIcon = styled.img.attrs({
    src: '/static/images/icons/check.svg'
})`

`;

export const TitleBlock = styled.div`
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  z-index: 2;
  margin-bottom: 16px;
  display: block;

  &:hover {
    overflow: visible;
    white-space: normal;
  }

  @media (max-width: 530px) {
    font-size: 16px;
  }
`;

export const Col = styled.div<{ display: string, oneRow: boolean, isCarousel: boolean }>`
  display: ${props => props.display || 'block'};
  min-height: ${props => props.oneRow ? '528px' : 'auto'};
  width: ${props => props.isCarousel ? 'auto' : 'fit-content'};
  height: ${props => props.isCarousel ? '100%' : 'auto'};
  
  @media (max-width: 836px) {
     max-width: ${({ isCarousel }) => isCarousel ? '100%' : '283px'};
     width: 100%;
     column-gap: 12px;
  }
  
  @media (max-width: 767px) {
     max-width: 100%;
  }
`;


export const PopupDescription = styled.div`
  height: fit-content;
  width: 100%;
  font-family: ${FONTS.regular};
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  white-space: pre-wrap;
  margin-bottom: 5px;
  color: ${COLORS.darkGrey};
  @media (max-width: 898px) {
    line-height: 18px;
  }
  @media (max-width: 713px) {
    font-size: 12px;
  }
  @media (max-width: 690px) {
    font-size: 14px;
    line-height: 20px;
  }
  @media (max-width: 350px) {
    font-size: 12px;
    line-height: 18px;
  }
`;

export const PopupButton = styled(StyledButton)`
  width: calc(50% - 8px);
  max-width: fit-content;
  height: fit-content;
  margin-bottom: 15px;
  @media (max-width: 530px) {
    width: 100%;
    max-width: initial;
    margin-bottom: 0;
  }
`;

export const ConfirmPopup = styled(DefaultPopup)`
  padding: 40px 60px 24px 60px;
  width: 50%;
  min-height: initial !important;
  max-width: 847px;
  min-width: 327px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  @media (max-width: 530px) {
    padding: 40px 20px;
    min-height: auto;
  }

  @media (max-width: 320px) {
    top: 36px;
    margin-bottom: 48px;
  }
`;

export const ConfirmPopupTitle = styled.div`
  position: relative;
  font-family: ${FONTS.light};
  max-width: 570px;
  font-size: 32px;
  line-height: 1.25;
  color: ${COLORS.black};
  text-overflow: ellipsis;
  z-index: 2;
  width: 100%;
  margin-bottom: 24px;
  &:hover {
    overflow: visible;
    white-space: normal;
  }
  @media (max-width: 767px) {
    font-size: 24px;
    line-height: 1.33;
  }
`;

export const ConfirmPopupDescription = styled(PopupDescription)<{ isYandex?: boolean }>`
  flex-direction: column;
  height: fit-content;
  width: 100%;
  font-family: ${FONTS.regular};
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  white-space: pre-wrap;
  margin-bottom: 24px;
  color: ${COLORS.darkGrey};

  p {
    font-family: ${FONTS.light};
    font-size: 16px;
    line-height: 1.5;

    :first-child {
      margin-bottom: ${({ isYandex }) => isYandex ? '24px' : '0'};
    }

    :last-child {
      margin-top: ${({ isYandex }) => isYandex ? '24px' : '0'};
    }
    
    @media (max-width: 767px) {
      font-size: 14px;
      line-height: 1.42;
    }
  }

  @media (max-width: 898px) {
    line-height: 18px;
  }
  @media (max-width: 713px) {
    font-size: 12px;
  }
  @media (max-width: 690px) {
    font-size: 14px;
    line-height: 20px;
  }
  @media (max-width: 350px) {
    font-size: 12px;
    line-height: 18px;
  }
`;

export const YandexLink = styled.a.attrs({
    href: 'https://yandex.ru/legal/yandex_plus_conditions/',
    target: '_blank',
    rel: 'noreferrer',
})`
  font-size: 16px;
  line-height: 1.5;

  @media(max-width: 767px) {
    font-size: 14px;
  }
`;

export const YandexPrice = styled.div`
  font-family: ${FONTS.regular};
  font-size: 18px;
  line-height: 1.333;
  margin: 24px 0;
  
  @media(max-width: 767px) {
    font-size: 14px;
  } 
`;


export const ConfirmPopupFooter = styled.div`
  justify-content: flex-start;
  flex-wrap: nowrap;
  column-gap: 12px;
  width: 100%;

  @media (max-width: 530px) {
    width: 100%;
    flex-direction: column;
  }

  div:first-child {
    max-width: 221px;
    margin-bottom: 0;
    @media (max-width: 767px) {
      width: 100%;
      margin-bottom: 5px;
      max-width: initial;
    }
  }
`;

export const Phone = styled(InputPhone)`
  display: block;
  width: calc(50% - 8px);
  min-width: 183px;
  margin-bottom: 0;
  @media (max-width: 530px) {
    width: 100%;
    margin-bottom: 8px;
  }
`;

export const Title = styled.p`
  position: relative;
  font-family: ${FONTS.medium};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: ${COLORS.black};
  text-overflow: ellipsis;
  z-index: 2;
  width: 100%;

  &:hover {
    overflow: visible;
    white-space: normal;
  }

  @media (max-width: 530px) {
    font-size: 16px;
  }
`;

export const Free = styled.p`
  display: flex;
  flex-direction: row;
  font-family: ${FONTS.regular};
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.darkGrey};
  margin-bottom: 3px;
`;

export const WrapperPrice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-height: 50px;
  justify-content: flex-end;
`;

export const PriceText = styled.p`
  font-family: ${FONTS.regular};
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  display: inline;
  margin-right: 10px;
  padding-top: 3px;
`;

export const Price = styled.p`
  font-family: ${FONTS.regular};
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  margin-right: 5px;
  color: ${COLORS.black};
`;

export const Label = styled.div<{ bgColor?: string }>`
  color: ${COLORS.white};
  font-family: ${FONTS.regular};
  font-size: 14px;
  line-height: 1.285;
  background: ${({ bgColor }) => bgColor ? bgColor : COLORS.black};
  align-items: center;
  padding: 0 8px;
  border-radius: 11px;
  height: fit-content;
  width: fit-content;
  min-height: 22px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Pic = styled.div<{ src?: string }>`
  width: 100%;
  height: 100%;
  background: url(${({ src }) => src}) center no-repeat;
  background-size: contain;
`;

export const Description = styled.div`
  width: 100%;
  height: 100%;
  display: block;
  font-family: ${FONTS.regular};
  font-style: normal;
  font-weight: normal;

  white-space: pre-wrap;
  overflow: hidden;
  margin-bottom: 8px;
  color: ${COLORS.darkGrey};
  @media (max-width: 898px) {
    line-height: 18px;
  }
  @media (max-width: 713px) {
    font-size: 12px;
  }
  @media (max-width: 690px) {
    font-size: 14px;
    line-height: 20px;
  }
  @media (max-width: 350px) {
    font-size: 12px;
    line-height: 18px;
  }
`;
